module.exports = __webpack_public_path__ + "static/img/pic15.15fd231.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/pic15.png
// module id = 1670
// module chunks = 2